module.exports = __webpack_public_path__ + "img/stock0.714385ef.png";